module.exports = __webpack_public_path__ + "static/img/5en.4cb0fb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/vivo/5en.png
// module id = dTI+
// module chunks = 0